<template>
  <div class="map-popup">
    <daum-map v-if="mapState === 'success'"
              :mapData="mapData"
              :setArea="true"
              :setInfoWindow="true"
    >
    </daum-map>
    <div class="loader-wrap" v-else>
      <loader v-if="mapState === 'load'"></loader>
      <div v-else-if="mapState === 'fail'" class="state-message">정보를 불러오지 못했습니다.</div>
      <div v-else-if="mapState === 'empty'" class="state-message">조회된 정보가 없습니다.</div>
    </div>
  </div>
</template>

<script>
  import api from '@/api/index'
  import Loader from 'common/components/Loader'
  import DaumMap from 'common/components/Map'

  export default {
    name: 'map-popup',
    props: {
    },
    data: function () {
      return {
        mapState: '',
        addressList: [],
        mapData: []
      }
    },
    components: { Loader, DaumMap },
    computed: {},
    watch: {},
    methods: {
      getMapInfo: function () {
        const vm = this
        vm.mapState = 'load'
        if (vm.addressList.length > 0) {
          // 지도 정보 API 호출
          api.getMapInfo(vm.addressList, response => {
            if (response.error) {
              vm.mapState = 'fail'
              // API 호출 실패 시
              console.log(response.source)
            } else {
              if (response['result'].length > 0) {
                vm.mapData = response['result']
                vm.mapState = 'success'
              } else {
                vm.mapState = 'empty'
              }
            }
          })
        }
      }
    },
    created: function () {
      const vm = this
      const token = localStorage.getItem('_t')
      const query = vm.$route.query
      // 토큰소유여부와 쿼리스트링으로 넘어온 주소지가 있는지 확인한다. (정상적인 방법으로 접근하였을 경우에만 페이지 실행)
      if (token) {
        // 넘어온 파라미터에 주소정보를 가지고 있을 경우, 주소정보를 배열형태로 저장한다.
        if (query && query.hasOwnProperty('address')) {
          // 토큰이 있을 경우, 유효한 토크인지를 판단한다.
          vm.$store.dispatch('inspectToken', token).then(() => {
            vm.addressList = query['address'].split(',')
            // 지도 정보 불러오기
            vm.getMapInfo()
          })
        } else {
          // 넘어온 주소 정보가 없을 경우, 인덱스 페이지로 redirect 처리.
          vm.$router.push({name: 'index'})
        }
      } else {
        // 정상적인 접근이 아닐 경우, 로그인 페이지로 redirect 처리.
        alert('로그인이 필요한 서비스입니다. 로그인 페이지로 이동합니다.')
        vm.$router.push({name: 'login'})
      }
    },
    mounted: function () {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .map-popup {
    width: 100%;
    height: 100%;
    text-align: center;
    padding: 0;
    margin: 0;
    .loader-wrap {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      text-align: center;
      background-color: #f5f5f5;
      z-index: 7 !important;
      .state-message {
        width: 100%;
        position: absolute;
        top: 50%;
        font-weight: bold;
        z-index: 5;
      }
      table, .have-child {
        opacity: 0.2;
      }
    }
    .loader-wrap-empty {
      background-color: $hzc-white;
      table {
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/MapPopup.vue